<template>
  <div>
    <div class="text-center" style="min-width: 150px">
      <div>
        <div class="caption">{{ desiredObject.name }}</div>
        <v-text-field
          v-if="desiredObject.type == 'number'"
          type="number"
          :min="desiredObject.min"
          :max="desiredObject.max"
          :step="desiredObject.step"
          v-model="localFormatted"
          :hide-details="true"
          dense
          outlined
          filled
          background-color="#FFF"
          :prefix="field == 'add' ? '+' : ''"
          :suffix="desiredObject.unit"
        >
        </v-text-field>
        <div v-else-if="desiredObject.type == 'list'">
          <v-btn-toggle
            label="toggle"
            v-model="local"
            dense
            rounded
            active-class="orangeActive"
            class="toggleBtns"
          >
            <v-btn
              v-for="item in desiredObject.items"
              :key="item.label"
              :value="item.value"
              small
            >
              {{ item.label }}
            </v-btn>
          </v-btn-toggle>
        </div>
      </div>
      <!-- <div v-if="desiredObject.unit" class="ml-2">{{ desiredObject.unit }}</div> -->
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "ClCalcsField",
  props: {
    field: null,
    fieldOptions: null,
    default: null,
    addOptions: null,
  },
  data: function () {
    return {
      local: null,
    };
  },
  methods: {},
  computed: {
    desiredObject: function () {
      let obj = null;
      if (this.field == "add") {
        obj = this.fieldOptions[this.addOptions];
      } else {
        obj = this.fieldOptions[this.field];
      }
      return obj;
    },
    localFormatted: {
      get: function () {
        if (this.desiredObject.type == "number") {
          return this.local?.toFixed(this.unitPrecision);
        } else return this.local;
      },
      set: function (newValue) {
        this.local = parseFloat(newValue);
      },
    },
    unitPrecision: function () {
      let step = this.desiredObject?.step;
      if (!step) return 0;
      let stepString = parseFloat(step).toString();
      let decPlaces = 0;
      if (stepString.includes(".")) {
        decPlaces = stepString.split(".")[1].length;
      }
      return decPlaces;
    },
  },
  watch: {
    local: function (val) {
      this.$emit("update", val);
    },
  },
  mounted() {
    this.local = this.default;
  },
};
</script>

<style scoped></style>
